import React, {useEffect, useState} from 'react';
import {FONT_FAMILIES} from "../../../../../documents/blocks/helpers/fontFamily";
import Select from "../../../../../../../components/input/select";

export function NullableFontFamily({label, onChange, defaultValue}) {
    const [value, setValue] = useState(defaultValue ?? 'inherit');

    useEffect(()=> {
        setValue(defaultValue);
    }, [defaultValue])

    return (
        <Select
            size="md"
            name="plan"
            value={value}
            isReady={true}
            label={label}
            options={FONT_FAMILIES}
            valueProp="key"
            onChange={ev => {
                setValue(ev.key);
                onChange(ev.key === null ? null : ev.key);
            }}
        />
    );
}
